import React, {useEffect, useMemo} from "react";
import {useForm} from "react-hook-form";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import InputEx from "../../../components/wrapperComponents/InputEx";
import {AziendaEditorProps} from "../Azienda.generalita.page";
import FormButtons from "../../../components/FormButtons";
import {useGetAziendeGiustQuery} from "@commons/features/azienda/tabelle/aziendaMapping.api";
import {ComboBoxGiustificativo} from "@components/comboBox/ComboBoxGiustificativo";
import {DAY_REPEAT_INMONTH, DAYS, GIORNI_RIF, MONTHS} from "@utilities/constAppUtils";
import {ComboBoxMesi} from "../../../components/comboBox/ComboBoxMesi";
import BooleanInput from "../../../components/BooleanInput";
import {ComboBoxGiorni} from "../../../components/comboBox/ComboBoxGiorni";

const FestivitaAziendaEditor: React.FC<AziendaEditorProps> = ({defaultValues, resource, onSubmit, onCancel}) => {
    const {watch, register, handleSubmit, reset, control, formState: {errors}} = useForm<AziendaRecord>();

    const initialValues: AziendaRecord = useMemo(() => {
        return {
            ...defaultValues, ...resource,
        };
    }, [resource, defaultValues]);

    useEffect(() => {
        reset(initialValues);
    }, [resource]);

    function onHandleSubmit(newValues: AziendaRecord) {
        onSubmit({
            ...newValues,
        })
    }

    const {data: dataGiust, isLoading: isLoadingGiust} = useGetAziendeGiustQuery({idAziendaMaster: resource.idAziendaCDIC});

    var SPApplicazione = watch('santoPatrono.applicaConvenzione');
    var SPDeterminazione = watch('santoPatrono.variabile');

    return <>
        <form className="p-1" onSubmit={handleSubmit(onHandleSubmit)}>

            <div className="flexRowWrapFull mb-4 sm:px-5">
                <div className="sm1-6P self-center">
                    GiustificativoBase festività nazionali
                </div>
                <div className="sm4-6P !pl-1">
                    <ComboBoxGiustificativo<AziendaRecord> label="Giustificativo" control={control} name="codGiustificativoFS" defaultValue={defaultValues.codGiustificativoFS}
                                                           data={dataGiust} isLoading={isLoadingGiust}
                    />
                </div>
            </div>

            {/*CHIUSURE AZIENDALI*/}
            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Chiusure aziendali</legend>

                {/*Chiusura azienda 1...*/}
                <div className="flexRowWrapFull">
                    <div className="sm1-6P self-center !pl-2">
                        Chiusura azienda 1
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Dal giorno"
                            name="chiusuraAziendale1.giornoDA"
                            register={register}
                        />
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Dal mese"
                            name="chiusuraAziendale1.meseDA"
                            register={register}
                        />
                    </div>
                </div>
                <div className="flexRowWrapFull">
                    <div className="sm1-6P"></div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Al giorno"
                            name="chiusuraAziendale1.giornoA"
                            register={register}
                        />
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Al mese"
                            name="chiusuraAziendale1.meseA"
                            register={register}
                        />
                    </div>
                </div>
                <div className="flexRowWrapFull border-b border-gray-200">
                    <div className="sm1-6P"></div>
                    <div className="sm4-6P mb-3">
                        <ComboBoxGiustificativo<AziendaRecord> label="Giustificativo" control={control} name="chiusuraAziendale1.codGiustificativo"
                                                               defaultValue={defaultValues.chiusuraAziendale1.codGiustificativo}
                                                               data={dataGiust} isLoading={isLoadingGiust}/>
                    </div>
                </div>

                {/*Chiusura azienda 2...*/}
                <div className="flexRowWrapFull">
                    <div className="sm1-6P self-center !pl-2">
                        Chiusura azienda 2
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Dal giorno"
                            name="chiusuraAziendale1.giornoDA" //todo: !!!! CHIUSURA AZIENDALE 2!!!!!!!!!!!!
                            register={register}
                        />
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Dal mese"
                            name="chiusuraAziendale1.meseDA"
                            register={register}
                        />
                    </div>
                </div>
                <div className="flexRowWrapFull">
                    <div className="sm1-6P"></div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Al giorno"
                            name="chiusuraAziendale1.giornoA"
                            register={register}
                        />
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Al mese"
                            name="chiusuraAziendale1.meseA"
                            register={register}
                        />
                    </div>
                </div>
                <div className="flexRowWrapFull border-b-gray-500">
                    <div className="sm1-6P"></div>
                    <div className="sm4-6P">
                        <ComboBoxGiustificativo<AziendaRecord> label="Giustificativo" control={control} name="chiusuraAziendale2.codGiustificativo"
                                                               defaultValue={defaultValues.chiusuraAziendale2.codGiustificativo}
                                                               data={dataGiust} isLoading={isLoadingGiust}/>
                    </div>
                </div>
            </fieldset>

            {/*SANTO PATRONO APPLICAZIONE*/}
            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Santo patrono applicazione</legend>

                <div className="flexRowWrapFull">
                    <div className="sm1-6P"></div>
                    <div className="sm4-6P">
                        <ComboBoxGiustificativo<AziendaRecord> label="Giustificativo" control={control} name="santoPatrono.codGiustificativo"
                                                               defaultValue={defaultValues.santoPatrono.codGiustificativo}
                                                               data={dataGiust} isLoading={isLoadingGiust}/>
                    </div>
                </div>

                <div className="flexRowWrapFull items-center mt-3">
                    <div className="sm1-6P !pl-2 mt-0">
                        Applicazione
                    </div>

                    <BooleanInput radioInline name="santoPatrono.applicaConvenzione" control={control}
                                  label4false="Data santo patrono"
                                  label4true="Altra data convenzionale"
                                  divClass="pl-2 sm2-6P"
                                  childrenClass="sm2-6P"
                                  inlineChildren={<>
                                      <div className="w-1/2 pr-2">
                                          <ComboBoxMesi<AziendaRecord> control={control} name="santoPatrono.meseConvenzione"
                                                                       defaultValue={defaultValues.santoPatrono.meseConvenzione}
                                                                       data={MONTHS} disabled={SPApplicazione === false}
                                          />
                                      </div>
                                      <div className="w-1/2 pl-2">
                                          <InputEx id="giornoSPConvenzione" label="Giorno" name="santoPatrono.giornoConvenzione"
                                                   register={register} disabled={SPApplicazione === false}/>
                                      </div>
                                  </>
                                  }
                    />
                </div>
            </fieldset>

            {/*SANTO PATRONO DETERMINAZIONE*/}
            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Santo patrono determinazione</legend>

                <div className="flexRowWrapFull">
                    <div className="sm1-6P"></div>
                    <div className="sm2-6P">
                        <ComboBoxMesi<AziendaRecord> data={MONTHS} defaultValue={defaultValues.santoPatrono.mese} name="santoPatrono.mese" control={control}/>
                    </div>
                </div>

                <div className="flex flex-row w-full mt-3">
                    <div className="sm1-6P !pl-2 mt-0">
                        Determinazione giorno
                    </div>

                    <BooleanInput name="santoPatrono.variabile" control={control}
                                  label4false="Fisso"
                                  label4true="Variabile"
                                  falseChild={
                                      <div className="sm1-4P">
                                          <InputEx id="giornoSPConvenzione" label="Giorno" name="santoPatrono.giornoFisso"
                                                   register={register} disabled={SPDeterminazione === true}/>
                                      </div>
                                  }
                                  trueChild={<>
                                      <ComboBoxGiorni<AziendaRecord> data={DAYS} label="Giorno SP" defaultValue={defaultValues.santoPatrono.giornoVariabile} divClass="sm1-4P"
                                                                     name="santoPatrono.giornoVariabile" control={control} disabled={SPDeterminazione === false}/>


                                      <ComboBoxGiorni<AziendaRecord> data={GIORNI_RIF} label="Riferimento" defaultValue={defaultValues.santoPatrono.tipoRiferimento} divClass="sm1-4P"
                                                                     name="santoPatrono.tipoRiferimento" control={control} disabled={SPDeterminazione === false}/>


                                      <ComboBoxGiorni<AziendaRecord> data={DAY_REPEAT_INMONTH} label="Giornata del mese" defaultValue={defaultValues.santoPatrono.giornata}
                                                                     divClass="sm1-4P"
                                                                     name="santoPatrono.giornata" control={control} disabled={SPDeterminazione === false}/>


                                      <ComboBoxGiorni<AziendaRecord> data={DAYS} label="Giorno riferimento" defaultValue={defaultValues.santoPatrono.giornoRiferimento} divClass="sm1-4P"
                                                                     name="santoPatrono.giornoRiferimento" control={control} disabled={SPDeterminazione === false}/>

                                  </>
                                  }
                    />
                </div>
            </fieldset>

            {/*ALTRE FESTIVITA'*/}
            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Altre festivit&agrave;</legend>

                <div className="flexRowWrapFull">
                    <div className="sm1-6P"></div>
                    <div className="sm4-6P">
                        <ComboBoxGiustificativo<AziendaRecord> label="Giustificativo" control={control} name="codGiustificativoFC"
                                                               defaultValue={defaultValues.codGiustificativoFC}
                                                               data={dataGiust} isLoading={isLoadingGiust}/>
                    </div>
                </div>
                <div className="flexRowWrapFull">
                    <div className="sm1-6P"></div>
                    <div className="sm2-6P">
                        <ComboBoxMesi<AziendaRecord> data={MONTHS} defaultValue={defaultValues.meseFC} name="meseFC" control={control}/>
                    </div>
                    <div className="sm2-6P">
                        <InputEx
                            label="Giorno"
                            name="giornoFC"
                            register={register}
                        />
                    </div>
                </div>
                <div className="flexRowWrapFull">
                    <div className="sm1-6P"></div>
                    <div className="sm4-6P">
                        <ComboBoxGiustificativo label="GiustificativoBase festivit&agrave; del 4 novembre" control={control} name="codGiustificativoFS_4_11"
                                                defaultValue={defaultValues.codGiustificativoFS_4_11} data={dataGiust} isLoading={isLoadingGiust}/>
                    </div>
                </div>
            </fieldset>

            <FormButtons onCancel={onCancel} resource={resource}/>
        </form>

    </>
}
export default FestivitaAziendaEditor;
